module.exports = {"140221100":"龙泉镇","140221101":"罗文皂镇","140221102":"大白登镇","140221103":"王官屯镇","140221104":"古城镇","140221105":"东小村镇","140221106":"友宰镇","140221201":"长城乡","140221202":"北徐屯乡","140221204":"狮子屯乡","140221209":"下深井乡","140221211":"马家皂乡","140221212":"鳌石乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140221.json
// module id = 244
// module chunks = 0